import React from "react"
import { daysOverdueVariant, DAYS_OVERDUE_STYLE } from "../constants"

export default function DaysOverdueBadge({ days }) {
  if (days == null) return null

  const variant = daysOverdueVariant(days)
  const style = DAYS_OVERDUE_STYLE[variant]

  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${style.cls}`}
    >
      {days <= 0 ? style.label : `${days}d overdue`}
    </span>
  )
}
